import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchPaymentMethods = createAsyncThunk(
  "payment-methods/fetch",
  async () => {
    const response = await API.get("/payment_methods")

    return response.data.payment_methods
  },
)
